import { render, staticRenderFns } from "./ProductConfigurationCreator.vue?vue&type=template&id=5c3eaf11&scoped=true"
import script from "./ProductConfigurationCreator.vue?vue&type=script&lang=js"
export * from "./ProductConfigurationCreator.vue?vue&type=script&lang=js"
import style0 from "./ProductConfigurationCreator.vue?vue&type=style&index=0&id=5c3eaf11&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_j7knk6mol3vthgvrc443rvn57u/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c3eaf11",
  null
  
)

export default component.exports